/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { budgetsUserDefaultEvents } from "../../funcs/budgetsUserDefaultEvents.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.ListUserDefaultBudgetEventsRequest$inboundSchema,
};

export const tool$budgetsUserDefaultEvents: ToolDefinition<typeof args> = {
  name: "budgets-user-default-events",
  description: `List per-user default budget events

Returns recent threshold-alert and block events for the org's per-user default budgets. Each event's target_id names the user it fired for. Targets the caller's own organization (inferred from the API key or session) unless the optional org_id query parameter names another org — cluster admins only. Callable by cluster admins, or org admins for their own organization (owner=org).`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await budgetsUserDefaultEvents(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
